module.exports = {
	folder_logos : "logos_sivi_v2",
	color_n : "#121212",
	color 	: "white",
	ext_bg  : "png", // | png | svg
	ext_mark : "png",
}; 